import { useMutation } from '@tanstack/react-query';
import { useToast } from '@/hooks/useToast';
import { fetchJson } from '@/lib/api';
import type { EmploymentEntry } from '@/lib/employment-extractor';

export const useExtractEmploymentHistory = () => {
  const { push } = useToast();

  return useMutation({
    mutationFn: (text: string) =>
      fetchJson<{ employmentHistory: EmploymentEntry[] }>(
        '/api/profile/employment-history',
        {
          body: JSON.stringify({ text }),
          headers: { 'Content-Type': 'application/json' },
          method: 'POST',
        },
      ),
    onError: (error: Error) =>
      push(error.message || 'Employment history extraction failed', 'error'),
  });
};
